export default __webpack_public_path__ + "static/media/Shot_33.0000.efff1040.png";